import React from "react";
import { useQuery } from "react-query";
import { getCategories } from "../../../MyApi/product/categories";
import { getCountries } from "../../../MyApi/admin/countries/countries";
import { getCities } from "../../../MyApi/admin/cities";

const CityFilter = ({filters, handleChange}) => {
  const { data, isLoading, isError } = useQuery(
    "getCities",  
    getCities
  );      

  const cities = data?.data?.cities || [];


  if (isError) return <p>Failed to load categories</p>;

  return (
    <div className="col-md-3 add">
      <select name="city_id" className="form-control" value={filters.city_id}  onChange={(e)=>handleChange("city_id",e.target.value)} disabled={isLoading}>
        <option value="">المدينة</option>

        {cities.map((city) => (
          <option key={city.id} value={city.id}>
            {city.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CityFilter;
